<template>
  <el-dialog :close-on-click-modal="false" append-to-body title="查看模板页" :visible.sync="isShow" width="750px">

    <el-form ref="addModuleForm" :model="addModuleVo" label-width="130px">
      <el-form-item label="模板页名称:" v-show="step===1">
        {{addModuleVo.name}}
      </el-form-item>
      <el-form-item label="是否关联设计版:" v-show="step===1">
        {{addModuleVo.isAssociatedePtsTemplate?'是':'否'}}
      </el-form-item>
      <el-form-item label="尺寸:" inline-message v-if="step===1&&addModuleVo.isAssociatedePtsTemplate">
        <span>{{addModuleVo.composeSize.sizeName}}</span>
      </el-form-item>
      <el-form-item label="模板页类型:" v-if="step===1&&addModuleVo.isAssociatedePtsTemplate">
        <span>{{addModuleVo.moduleAttribute.attrName}}</span>
      </el-form-item>

      <el-form-item label="模板页信息:" prop="list" v-show="step===2">

        <el-table :data="addModuleVo.moduleInfoXrefs" ref="selectmoduleInfoList" row-key="infoId" class="dragModuleInfo" border
          style="width: 600px;margin: 10px 0;">
          <el-table-column prop="refInfo.name" label="模板页信息"></el-table-column>
          <el-table-column prop="refInfo.infoType" label="类型">
            <template slot-scope="scope">
              <span v-if="scope.row.infoType==='TEXT'">文本</span>
              <span v-if="scope.row.infoType==='IMAGE'">图片</span>
            </template>
          </el-table-column>
          <el-table-column prop="refInfo.infoValue" label="限制" width="200px"></el-table-column>
          <el-table-column label="模板页内容" prop="refInfo.content" v-if="addModuleVo.isAssociatedePtsTemplate"></el-table-column>
        </el-table>
      </el-form-item>

    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" round v-show="step===1" @click="step=2">下一步</el-button>
      <el-button type="primary" round v-show="step===2" @click="step=1">上一步</el-button>
      <el-button type="primary" round v-show="step===2" @click="hide()">确 定</el-button>
    </span>

  </el-dialog>
</template>

<script>

export default {
  data () {
    return {
      isShow: false,
      step: 1,
      addModuleVo: {
        composeSize: {},
        moduleAttribute: {}
      },
      selectedInfoList: []

    }
  },
  methods: {
    show (info) {
      console.log(info)
      this.addModuleVo = info
      this.isShow = true
    },
    hide () {
      this.step = 1
      this.isShow = false
    }
  }
}
</script>

<style lang="less" scoped>
@deep: ~">>>";

.infoValue {
  @{deep} .el-input {
    width: 40px;
    input {
      padding: 0 2px;
      text-align: center;
    }
  }
}
.action_btn {
  display: block;
  width: 70px;
  height: 22px;
  border-radius: 22px;
  background: #f2f2f2;
  border: 1px solid #cccccc;
  font-size: 12px;
  font-family: Source Han Sans CN, Source Han Sans CN-Light;
  font-weight: 300;
  text-align: center;
  color: #2e7cd4;
  margin: 5px auto;
  cursor: pointer;
}
</style>
